export const createBootstrapWorkerClient = () => {
  if (typeof Worker === 'undefined') return null;

  let worker;
  try {
    worker = new Worker(new URL('../workers/bootstrapWorker.js', import.meta.url));
  } catch (error) {
    return null;
  }

  let nextId = 0;
  const pending = new Map();

  worker.onmessage = (event) => {
    const { id, kind, result, error, stage, progress } = event.data || {};
    if (!pending.has(id)) return;
    const entry = pending.get(id);

    if (kind === 'progress') {
      if (entry.onProgress) entry.onProgress({ stage, progress });
      return;
    }

    pending.delete(id);

    if (kind === 'result') {
      entry.resolve(result);
      return;
    }

    if (kind === 'error') {
      entry.reject(new Error(error?.message || 'Bootstrap worker error'));
    }
  };

  worker.onerror = (event) => {
    pending.forEach(({ reject }) => {
      reject(new Error(event?.message || 'Bootstrap worker error'));
    });
    pending.clear();
  };

  const runJob = (type, payload, onProgress) => new Promise((resolve, reject) => {
    const id = nextId + 1;
    nextId = id;
    pending.set(id, { resolve, reject, onProgress });
    worker.postMessage({ id, type, payload });
  });

  const terminate = () => {
    if (!worker) return;
    pending.forEach(({ reject }) => {
      reject(new Error('Bootstrap worker terminated'));
    });
    pending.clear();
    worker.terminate();
  };

  return {
    runJob,
    terminate,
  };
};
